import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useYoutubeVideoLinkData = () => {
  const [links, setLinks] = useState([]);
  const [loadingLink, setLoading] = useState(true);
  const [errorLink, setError] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch(apiUrl("youtubeVideoList"));
        if (!response.ok) {
          throw new Error("Failed to fetch ");
        }
        const data = await response.json();
        setLinks(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  return { links, loadingLink, errorLink };
};

export default useYoutubeVideoLinkData;
